import type { ReconciliationDecisions, ReconciliationModel } from './types';

/**
 * Décisions par défaut : valeurs reconnues → mapper vers le nom canonique
 * (garantit le matching exact côté V2) ; non reconnues → créer si possible,
 * sinon ignorer.
 */
export function initDecisions(model: ReconciliationModel): ReconciliationDecisions {
  const decisions: ReconciliationDecisions = {};
  for (const [logicalName, file] of Object.entries(model.files)) {
    decisions[logicalName] = {};
    for (const col of file.columns) {
      decisions[logicalName][col.column] = {};
      for (const v of col.values) {
        if (v.status === 'matched') {
          decisions[logicalName][col.column][v.value] = {
            action: 'map',
            target: v.matchedLabel ?? v.value,
          };
        } else {
          decisions[logicalName][col.column][v.value] = {
            action: col.creatable ? 'create' : 'ignore',
          };
        }
      }
    }
  }
  return decisions;
}
